import React from "react";
import { Box, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

interface SearchFieldProps {
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchField: React.FC<SearchFieldProps> = ({
  placeholder,
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e0e0",
        borderRadius: "8px",
        padding: "4px 8px",
        direction: "rtl", // Right-to-left layout
        textAlign: "right", // Align text to the right
      }}
    >
     
      <TextField
        variant="standard"
        placeholder={placeholder}
        fullWidth
        InputProps={{ disableUnderline: true }}
        value={value}
        onChange={onChange}
        sx={{ ml: 1,mr:1 }}
      />
       <SearchIcon sx={{ color: "gray" }} />
    </Box>
  );
};

export default SearchField;
